<template>
    <div class="pageDiv">
        <v-card class="main-card" v-if="!$AuthSvc.isLogin()">
          <v-card-text>
            <span class="label14 darkred">Login is required to view data</span>
          </v-card-text>
        </v-card>

        <v-card class="main-card" v-if="$AuthSvc.isLogin()">
            <v-card-title style="padding-bottom:0">
                <span class="page-title">{{$AuthSvc.getYear()}} Texas Cup Leaders</span>
            </v-card-title>

            <v-card-text v-if="leaders.length > 0">
                <ul class="ulSquare">
                    <li>Highlighted GREEN are Texas Cup qualifiers</li>
                    <li>Highlighted GRAY are Lao Cup qualifiers</li>
                </ul>
                <br>
                <v-simple-table class="simple-table">
                    <tr>
                        <th width="10px">#</th>
                        <th width="68%">Name</th>
                        <th width="40px">Flight</th>
                        <th width="60px">Points</th>
                        <th v-if="!$AuthSvc.isMobile()" width="60px">Shirt Size</th>
                    </tr>
                    <tr v-for="(leader, index) in leaders"  :key="leader.playerId">
                        <td :class="{texasCup: index < 38, challengeCup: index >= 38 && index < 52}">{{index+1}}</td>
                        <td :class="{texasCup: index < 38, challengeCup: index >= 38 && index < 52}">
                            {{leader.firstName}}
                            {{leader.middleName!==null && leader.middleName!==''?leader.middleName.charAt(0):''}}
                            {{leader.lastName}}</td>
                        <td :class="{texasCup: index < 38, challengeCup: index >= 38 && index < 52}">{{leader.flight}}</td>
                        <td :class="{texasCup: index < 38, challengeCup: index >= 38 && index < 52}">{{parseFloat(leader.point).toFixed(1)}}</td>
                        <td :class="{texasCup: index < 38, challengeCup: index >= 38 && index < 52}" v-if="!$AuthSvc.isMobile()">
                            {{leader.shirtSize}}
                        </td>
                    </tr>
                </v-simple-table>
            </v-card-text>

            <v-card-text v-if="leaders.length === 0">
                <v-simple-table class="simple-table">
                    <tr>
                        <th width="10px">#</th>
                        <th width="68%">Name</th>
                        <th width="40px">Flight</th>
                        <th width="60px">Points</th>
                    </tr>
                    <tr>
                        <td></td>
                        <td>No data available</td>
                        <td></td>
                        <td></td>
                    </tr>
                </v-simple-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
  export default {
    name: "login",
    data: () => ({
      count: 0,
      leaders: []
    }),
    mounted: function() {
       this.$AuthSvc.authenticated(this.successAuth());
    },
    methods: {
      successAuth() {
        var _this = this;

        this.axios.get('/public/cup/leaders')
        .then(function (response) {
             _this.leaders = response.data;
        })
        .catch(function (error) {
            console.log('ERROR: ' + error);
        });
      },
      incrementCount: function() {
        this.count++;
        return this.count;
      }
    }
  }

</script>

<style scoped>

  @media (min-width: 768px) {

  }

  .texasCup {
    background-color: lightgreen;
  }

  .challengeCup {
    background-color: lightgrey;
  }

</style>